import '../../../config';
export const ALLOWED_FIELDS_CONTACT_DATA = [
    'email',
    'locale',
    'firstName',
    'lastName',
    'company',
    'gender',
    'jobTitle',
    'otherEmails',
    'streetName',
    'postalCode',
    'city',
    'countryCode',
    'phone',
    'otherPhones',
    'faxes',
    'meta',
    'category',
    'distributionList',
    'supportedDist'
];
export const SUPPORTED_DISTRIBUTION_LIST = [
    'ad-hoc-news',
    'corporate-news',
    'private-investor',
    'institutional-investor',
    'analyst',
    'journalist',
    'other'
];
